<template>
    <p>pazienti eventi</p>
</template>

<script>
export default {};
</script>

<style></style>
